import type { SalaryTrancheListItem } from '../plantillaTypes';

/** The URL of one tranche's profile — the type by its number, as the API addresses it. */
export const salaryTranchePath = (tranche: Pick<SalaryTrancheListItem, 'type' | 'tranche'>) =>
  `/organization/settings/salary-grades/${tranche.type}/${tranche.tranche}`;
